import React from 'react';
import {StyleSheet, View} from 'react-native';
import {Props} from './model';
import {VisuallyImpairedButton} from '../button';

export default <T extends number>({value, onChange, items}: Props<T>) => {
  const styles = useStyles();

  return (
    <View style={styles.container}>
      {items.map((item) => (
        <VisuallyImpairedButton
          key={item.value}
          label={item.title}
          onPress={() => {
            onChange(item.value);
          }}
          active={value === item.value}
          style={[styles.button, item.styles?.container]}
          textStyle={[item.styles?.text ?? {}, value === item.value && item.styles?.activeText]}
        />
      ))}
    </View>
  );
};

const useStyles = () =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
    },
    button: {
      marginRight: 5,
    },
  });
